module.exports = __webpack_public_path__ + "static/media/fish_farm_header.0d651f6a.jpg";